<!--
 * @Description: file content
 * @Author: yangsibo
 * @Date: 2022-06-06 09:39:33
 * @LastEditors: yangsibo
 * @LastEditTime: 2022-06-07 14:58:55
 * @FilePath: \YunYin_admin\src\views\Village\SetQuery\Log.vue
-->
<template>
  <LogList :dataSource="-1"></LogList>
</template>

<script>
import LogList from "@/components/Query/LogList";
export default {
  name: "Log",
  data() {
    return {};
  },
  components: { LogList },
  mounted() {},
};
</script>

<style lang="scss" scoped>
</style>
